import { render } from "./DepotCard.vue?vue&type=template&id=79cb6230&scoped=true"
import script from "./DepotCard.vue?vue&type=script&lang=js"
export * from "./DepotCard.vue?vue&type=script&lang=js"

import "./DepotCard.vue?vue&type=style&index=0&id=79cb6230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cb6230"]])

export default __exports__